// import React from 'react';
// import { PieChart } from '@mui/x-charts/PieChart';

// const PieChartData = ({ piechartData }) => {
//   const showData = piechartData?.data || [];
//   return (
//     <PieChart
//       margin={{ top: 50, bottom: 30, left: 30, right: 30 }}

//       slotProps={{
//         legend: {
//           direction: 'row',
//           position: { vertical: 'top', horizontal: 'middle' },
//           padding: 0,
//         },
//       }}
//       series={[
//         {
//           highlightScope: { fade: 'global', highlight: 'item' },
//           faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
//           data: showData?.map((item, index) => ({
//             id: index,
//             value: `${item.totalSystemSizeKw}` || 0,
//             label: `${item.type}: ${Number(item.percentage || 0).toFixed(2)}%`,
//           })),
//         },
//       ]}
//     />
//   );
// };

// export default PieChartData;

import React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { Box, Typography } from '@mui/material';

const PieChartData = ({ piechartData }) => {
  const showData = (piechartData?.data || []).map((item, index) => ({
    id: index,
    value: Number(item.totalSystemSizeKw) || 0,
    label: `${item.type}: ${Number(item.percentage || 0).toFixed(2)}%`,
    color: item.type === 'Residential' ? '#00bfa5' : '#2979ff', // Maintain colors
  }));

  // Create a reversed copy specifically for the legend
  const legendData = [...showData].reverse();

  return (
    <Box sx={{ width: '100%' }}>
      {/* Custom Legend to control order manually */}
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 2 }}>
        {legendData.map((item) => (
          <Box key={item.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 15, height: 15, bgcolor: item.color }} />
            <Typography variant="body2">{item.label}</Typography>
          </Box>
        ))}
      </Box>

      <PieChart
        margin={{ top: 10, bottom: 30, left: 30, right: 30 }}
        slotProps={{
          legend: { hidden: true }, // Hide the default legend
        }}
        series={[
          {
            data: showData, // Keeps original chart order
            highlightScope: { fade: 'global', highlight: 'item' },
            faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
          },
        ]}
        height={300}
      />
    </Box>
  );
};

export default PieChartData;